export enum PresentationType {
	CODE = 'CODE',
	DESCRIPTION = 'DESCRIPTION',
	PRESENTATION = 'PRESENTATION',
}
